module.exports = __webpack_public_path__ + "static/media/SANIDAD-INTERIOR_2.29d42732.png";